import axios from 'axios';

// Use environment variable in production, localhost in development
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export default api;
